import { Autocomplete, Box, Button, Container, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import axios from "axios";
import Api from '../../customlib/Api';
import Global from '../../customlib/Global';
import moment from 'moment';
import DateRangePickerRich from '../../customlib/DateRangePickerRich';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Title, PointElement, LineElement } from 'chart.js';
import { Bar, Line, Pie, } from 'react-chartjs-2';
import groupBy from 'json-groupby';
import { ErrorOutline, Refresh } from '@mui/icons-material';

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, 
    CategoryScale,
    LinearScale,
    BarElement,
    Title, 
    PointElement,
    LineElement);

class ReportPerformaDataCancelNew extends Component {
    state = { 
        startDate: moment().tz("asia/jakarta"),
        endDate: moment().tz("asia/jakarta"),
        users: [],
        selectedUser: {id: 0, name: "ALL CS"},
        isCancelDistributionLoading: false,
        dataCancelDistribution: {
            labels: [],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1,
                },
            ],
            options: {
                responsive: true
            }
        },
        dataCancelRate: {
            labels: [],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1,
                },
            ],
            options: {
                responsive: true
            }
        },
        dataCancelBySales: {
            labels: [],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1,
                },
            ],
        },
        dataCancelByProduct: {
            labels: [],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1,
                },
            ],
        },
        dataCancelByCity: {
            labels: [],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1,
                },
            ],
        },
        
        isLoadingDataCancel: false,
        totalLeads: 0,
        totalCancel: 0,
        cancelRate: 0,
        topCancel: "-",
        listLeadsCancel: [],
        byGroupReason: [],//cancel distribution {groupReason, leads}
        bySales: [],//cancel by sales {salesid, salesName, leads}
        byDate: [],//cancel rate {date, leads}
        byProduct: [],//cancel by product {productCategory, leads}
        byCity: [],//cancel by city {cityName, leads}
        groupedLeadsCancel: []

     } 

    loadCsLeadsReport = () => {
        this.setState({csLeadsReporLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csLeadsReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    if(data.success === true){
                        this.setState({csLeadsReporLoading: false, csLeadsReport: data.data});
                    }else{
                        this.setState({csLeadsReporLoading: false, csLeadsReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csLeadsReporLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    chartColors = [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(60, 52, 57, 1)',
        'rgba(12, 236, 94, 1)',
        'rgba(98, 105, 43, 1)',
        'rgba(158, 180, 237, 1)',
        'rgba(228, 164, 239, 1)',
        'rgba(145, 86, 86, 1)',
    ];

    loadCustomerCancelPendingByFirstLabel = () => {
        this.setState({isLoadingDataCancel: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.customerCancelPendingByFirstLabel(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    console.log("DATA_CANCEL", data);

                    let totalLeads = data.data.countAllLeads;
                    let totalCancel = data.data.leadsCancelPending.length;
                    let cancelRate = totalLeads > 0 ? (totalCancel/totalLeads*100) : 0;

                    const leadsCountByDate = data.data.leadsCountByDate;
                    // First level grouping by 'category'
                    const grouped = groupBy(data.data.leadsCancelPending, ["firstContactAssignedToName","groupReason", "reason"]);
                    console.log("GROUPED", grouped);
                    let flatenedGroup = [];
                    for(const root in grouped){
                        const groupSales = grouped[root];
                        // console.log("GROUPED", root, groupSales);
                        for(const bySales in groupSales){
                            const groupReason = groupSales[bySales];
                            for(const byGroupReason in groupReason){
                                const reason = groupReason[byGroupReason];
                                // console.log("GROUPED", root, bySales, byGroupReason, reason);
                                flatenedGroup.push({
                                    salesName: root,
                                    groupReason: bySales,
                                    reason: byGroupReason,
                                    leads: reason
                                });
                            }
                        }
                    }

                    console.log("FLATENED", flatenedGroup);

                    let byGroupReason = [];
                    let byCancelRate = [];
                    let bySales = [];
                    let byDate = [];
                    let byProduct = [];
                    let byCity = [];
                    data.data.leadsCancelPending?.forEach(item => {
                        let findByGroupReason = byGroupReason.find(obj => obj.groupReason === item.groupReason);
                        if(findByGroupReason){
                            findByGroupReason.leads.push(item);
                        }else{
                            byGroupReason.push(
                                {
                                    groupReason: item.groupReason,
                                    leads: [item]
                                }
                            );
                        }

                        let findBySales = bySales.find(obj => obj.salesId === item.firstContactAssignedTo);
                        if(findBySales){
                            findBySales.leads.push(item);
                        }else{
                            bySales.push(
                                {
                                    salesId: item.firstContactAssignedTo,
                                    salesName: item.firstContactAssignedToName,
                                    leads: [item]
                                }
                            );
                        }

                        let formattedCreatedAt = Global.formatDateTimeToStrFormat(item.created_at, "Y-M-D");
                        let findByDate = byDate.find(obj => Global.formatDateTimeToStrFormat(obj.date, "Y-M-D") === formattedCreatedAt);
                        const findLeadsCountByDate = leadsCountByDate.find(leadByDate => leadByDate.date === formattedCreatedAt);
                        if(findByDate){
                            findByDate.leads.push(item);
                            if(findLeadsCountByDate && findLeadsCountByDate.count > 0){
                                findByDate.rate = parseFloat((findByDate.leads.length/findLeadsCountByDate.count*100).toFixed(1));
                            }
                        }else{
                            if(findLeadsCountByDate && findLeadsCountByDate.count > 0){
                                byDate.push(
                                    {
                                        date: formattedCreatedAt,
                                        leads: [item],
                                        rate: parseFloat((1/findLeadsCountByDate.count*100).toFixed(1))
                                    }
                                );
                            }else{
                                byDate.push(
                                {
                                    date: formattedCreatedAt,
                                    leads: [item],
                                    rate: 0
                                }
                            );
                            }
                            
                        }

                        let findByProduct = byProduct.find(obj => obj.productCategory === item.productCategory);
                        if(findByProduct){
                            findByProduct.leads.push(item);
                        }else{
                            byProduct.push(
                                {
                                    productCategory: item.productCategory,
                                    leads: [item]
                                }
                            );
                        }

                        let findByCity = byCity.find(obj => obj.cityName === item.cityName);
                        if(findByCity){
                            findByCity.leads.push(item);
                        }else{
                            byCity.push(
                                {
                                    cityName: item.cityName,
                                    leads: [item]
                                }
                            );
                        }
                    });

                    const chartDataCancelDistribution = {...this.state.dataCancelDistribution};
                    let arrLabelsCancelDistribution = [];
                    let arrDataCancelDistribution = [];
                    byGroupReason.forEach(element => {
                        arrLabelsCancelDistribution.push(element.groupReason);
                        arrDataCancelDistribution.push(element.leads.length);
                    });
                    chartDataCancelDistribution.labels = arrLabelsCancelDistribution;
                    chartDataCancelDistribution.datasets[0].backgroundColor = this.chartColors;
                    chartDataCancelDistribution.datasets[0].borderColor = this.chartColors;
                    chartDataCancelDistribution.datasets[0].data = arrDataCancelDistribution;
                    
                    const chartDataBySales = {...this.state.dataCancelBySales};
                    let arrLabelsBySales = [];
                    let arrDataBySales = [];
                    bySales.forEach(element => {
                        arrLabelsBySales.push(element.salesName);
                        arrDataBySales.push(element.leads.length);
                    });
                    chartDataBySales.labels = arrLabelsBySales;
                    chartDataBySales.datasets[0].backgroundColor = this.chartColors;
                    chartDataBySales.datasets[0].borderColor = this.chartColors;
                    chartDataBySales.datasets[0].data = arrDataBySales;
                    
                    const chartDataByProduct = {...this.state.dataCancelByProduct};
                    let arrLabelsByProduct = [];
                    let arrDataByProduct = [];
                    byProduct.forEach(element => {
                        arrLabelsByProduct.push(element.productCategory);
                        arrDataByProduct.push(element.leads.length);
                    });
                    chartDataByProduct.labels = arrLabelsByProduct;
                    chartDataByProduct.datasets[0].backgroundColor = this.chartColors;
                    chartDataByProduct.datasets[0].borderColor = this.chartColors;
                    chartDataByProduct.datasets[0].data = arrDataByProduct;

                    const chartDataByCity = {...this.state.dataCancelByCity};
                    let arrLabelsByCity = [];
                    let arrDataByCity = [];
                    byCity.forEach(element => {
                        arrLabelsByCity.push(element.cityName);
                        arrDataByCity.push(element.leads.length);
                    });
                    chartDataByCity.labels = arrLabelsByCity;
                    chartDataByCity.datasets[0].backgroundColor = this.chartColors;
                    chartDataByCity.datasets[0].borderColor = this.chartColors;
                    chartDataByCity.datasets[0].data = arrDataByCity;
                    
                    const chartDataByDate = {...this.state.dataCancelRate};
                    let arrLabelsByDate = [];
                    let arrDataByDate = [];
                    byDate.forEach(element => {
                        arrLabelsByDate.push(element.date);
                        arrDataByDate.push(element.rate);
                    });
                    chartDataByDate.labels = arrLabelsByDate;
                    chartDataByDate.datasets[0].backgroundColor = this.chartColors;
                    chartDataByDate.datasets[0].borderColor = this.chartColors;
                    chartDataByDate.datasets[0].data = arrDataByDate;
                    
                    let topCancel = "-";
                    let lastCount = 0;
                    flatenedGroup.forEach(itemGroup => {
                        if(itemGroup.leads.length >= lastCount){
                            topCancel = itemGroup.groupReason ?? "";
                            lastCount = itemGroup.leads.length;
                        }
                    });
                    flatenedGroup.sort((a, b) => {
                        // a.salesName.localeCompare(b.salesName)}
                        if(a.salesName < b.salesName) return -1;
                        if(a.salesName > b.salesName) return 1;

                        if(a.groupReason ?? "" < b.groupReason ?? "") return -1;
                        if(a.groupReason ?? "" > b.groupReason ?? "") return 1;

                        return b.leads.length - a.leads.length;

                    });
                    this.setState({
                        isLoadingDataCancel: false, 
                        totalCancel: totalCancel,
                        totalLeads: totalLeads,
                        cancelRate: cancelRate,
                        topCancel: topCancel,
                        listLeadsCancel: data.data.leadsCancelPending,
                        byGroupReason: byGroupReason,
                        bySales: bySales,
                        byDate: byDate,
                        byProduct: byProduct,
                        byCity: byCity,
                        dataCancelDistribution: chartDataCancelDistribution,
                        dataCancelBySales: chartDataBySales,
                        dataCancelRate: chartDataByDate,
                        dataCancelByProduct: chartDataByProduct,
                        dataCancelByCity: chartDataByCity,
                        groupedLeadsCancel: flatenedGroup
                    }, () => {
                        console.log("CHART_DATA", byDate);
                    });
                })
                .catch((error) => {
                  this.setState({isLoadingDataCancel: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsComplainCategoriesReport = () => {
        this.setState({csComplaintCategoriesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csComplaintCategoriesReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsComplaintCategories};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.complaintCategory);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;

                        this.setState({csComplaintCategoriesLoading: false, csComplaintCategoriesReport: data.data, dataCsComplaintCategories: chartData}, () => {
                            console.log("dataCsComplaintCategories", this.state.dataCsComplaintCategories);
                        });
                    }else{
                        this.setState({csComplaintCategoriesLoading: false, csComplaintCategoriesReport: [], dataCsComplaintCategories: chartData});
                    }
                })
                .catch((error) => {
                  this.setState({csComplaintCategoriesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsHelpCategoriesReport = () => {
        this.setState({csHelpCategoriesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csHelpCategoriesReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsHelpCategories};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.helpCategory);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;
                        this.setState({csHelpCategoriesLoading: false, csHelpCategoriesReport: data.data, dataCsHelpCategories: chartData});
                    }else{
                        this.setState({csHelpCategoriesLoading: false, csHelpCategoriesReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csHelpCategoriesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsSatisfactionReport = () => {
        this.setState({csSatisfactionLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csCustomerSatisfactionReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsCustomerSatisfaction};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.review);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;
                        this.setState({csSatisfactionLoading: false, csSatisfactionReport: data.data, dataCsCustomerSatisfaction: chartData});
                    }else{
                        this.setState({csSatisfactionLoading: false, csSatisfactionReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csSatisfactionLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsRevisionNotes = () => {
        this.setState({csRevisionNotesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    appProfileId: Global.getAppProfile()._id,
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csRevisionNotes(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    if(data.success === true){
                        this.setState({csRevisionNotesLoading: false, csRevisionNotes: data.data});
                    }else{
                        this.setState({csRevisionNotesLoading: false, csRevisionNotes: []});
                    }
                })
                .catch((error) => {
                  this.setState({csRevisionNotesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadUsersBySlugRoles = () => {
    
            const params = {
                slugRoles: ["customer-service", "cs-purchase", "purchasing", "cs-payment", "rangkaian-bunga"]
                // slugRole: "account-executive"
            };
    
            axios
            // .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeader())
            .post(Api.userBySlugRoles(), params, Api.getRequestHeader())
            .then((response) => {
                console.log("SALESTELEUSER : ", response.data.data);
                let usersData = [{id: 0, name: "All CS"}];

                response.data.data.forEach(item => {
                    usersData.push(item);
                });
                this.setState({users: usersData});
            })
            .catch((error) => {
                console.error("There was an error!", error);
            });
        };

    componentDidMount(){
        this.reloadAll();
    }

    reloadAll = () => {
        this.loadUsersBySlugRoles();
        this.loadCustomerCancelPendingByFirstLabel();
    }

    handleDateChanged = (dateRange) => {
        if(dateRange && dateRange[0] && dateRange[1]){
            this.setState({startDate: dateRange[0], endDate: dateRange[1]}, () => {
                this.reloadAll();
            })
        }
    }

    handleSelectionChanged = (selected) => {
        console.log(`SELECTED : ${selected}`);
        let findSelectedUser = this.state.users.find(item => item.name === selected);

        if(findSelectedUser){
            this.setState({selectedUser: findSelectedUser}, this.reloadAll);
        }
    }

    handleCbUserChanged = (event) => {
        console.log(`SELECTED : ${event.target.value}`);
        // let findSelectedUser = this.state.users.find(item => item.name === selected);

        // if(findSelectedUser){
            this.setState({selectedUser: event.target.value}, this.reloadAll);
        // }
    }

    render() { 

        if(!Global.get().admin && !Global.isTeleLeader()){
            return (
                <div className='container text-center' style={{marginTop: 100}}>
                    <ErrorOutline style={{width: 200, height: 200}} className="text-danger" />
                    <h2>Lotus</h2>
                    <h3>Permission denied</h3>
                    {/* <Link style={{textDecoration: "underline", width: '100%'}} to="/">
                        <div className="btn btn-warning">Back</div>
                    </Link> */}
                </div>
            );
        }

        return (
            <Box>
                <Grid container spacing={1}>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4} textAlign={"right"}>
                        {/* <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">CS Name</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={this.state.selectedUser}
                                label="Cs Name"
                                onChange={this.handleCbUserChanged}
                            >
                                {
                                    this.state.users.map((item, index) => <MenuItem value={item}>{item.name}</MenuItem>)
                                }
                            </Select>
                            </FormControl> */}
                        {/* <Autocomplete
                            id="free-solo-2-demo"
                            disableClearable = {true}
                            freeSolo 
                            size='small'
                            options={this.state.users.map((option) => {
                                // console.log("LABEL : ", option);
                                // return String(`${option.name} (${option.email})`) ;
                                return String(`${option.name}`) ;
                            })}
                            sx={{mt: '5px'}}
                            onChange={(event, newValue) => {
                                // console.log("NEWVALUE : ", event);
                                this.handleSelectionChanged(newValue);
                            }}
                            // value={this.state.contactData.lavenderSalesName}
                            value={this.state.selectedUser?.name ?? ""}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Nama CS"
                                // margin="0"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                                size='small'
                            />
                            )}
                        /> */}
                    </Grid>
                    <Grid item xs={1} textAlign={"left"}>
                        <Box sx={{mt: "10px"}}>Tanggal : </Box>
                    </Grid>
                    <Grid item xs={2}>
                        <Box sx={{mt: "5px"}}>
                            <DateRangePickerRich title={"Tanggal Transaksi"} startDate={this.state.startDate} endDate={this.state.endDate} onDateChanged={this.handleDateChanged} />
                        </Box>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton variant='contained' color='primary' onClick={this.reloadAll}><Refresh /></IconButton>
                    </Grid>
                </Grid>
                <Divider sx={{mt: "10px", mb: "10px", color: "blue"}} />
                
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        {
                            this.state.isLoadingDataCancel && <LinearProgress />
                        }
                        <Paper elevation={2} sx={{padding: "10px"}}>
                            <Typography variant='h6'>Total Cancel</Typography>
                            <Typography variant='h4'>{this.state.totalCancel}</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={4}>
                        {
                            this.state.isLoadingDataCancel && <LinearProgress />
                        }
                        <Paper elevation={2} sx={{padding: "10px"}}>
                            <Typography variant='h6'>Cancel Rate</Typography>
                            <Typography variant='h4'>{this.state.cancelRate.toFixed(2)}%</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={4}>
                        {
                            this.state.isLoadingDataCancel && <LinearProgress />
                        }
                        <Paper elevation={2} sx={{padding: "10px"}}>
                            <Typography variant='h6'>Top Cancel</Typography>
                            <Typography variant='h4'>{this.state.topCancel}</Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={4}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                                    <strong>Cancel Distribution</strong>
                                    {
                                        this.state.isLoadingDataCancel ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                                    }
                                    <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                        {
                                            this.state.isLoadingDataCancel ? <></> : 
                                            <Pie data={this.state.dataCancelDistribution} />
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                            {/* <Grid item xs={6}>
                                <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                                    <strong>Cancel By Sales</strong>
                                    {
                                        this.state.isLoadingDataCancel ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                                    }
                                    <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                        {
                                            this.state.isLoadingDataCancel ? <></> : 
                                            <Bar data={this.state.dataCancelBySales} />
                                        }
                                    </Box>
                                </Box>
                            </Grid> */}
                        </Grid>
                        
                    </Grid>
                    <Grid item xs={8}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>Cancel Rate</strong>
                            {
                                this.state.isLoadingDataCancel ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                {
                                    this.state.isLoadingDataCancel ? <></> : 
                                    <Line data={this.state.dataCancelRate} />
                                }
                            </Box>
                        </Box>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>Cancel By Sales</strong>
                            {
                                this.state.isLoadingDataCancel ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                {
                                    this.state.isLoadingDataCancel ? <></> : 
                                    <Bar data={this.state.dataCancelBySales} />
                                }
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                                    <strong>Cancel By Product</strong>
                                    {
                                        this.state.isLoadingDataCancel ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                                    }
                                    <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                        {
                                            this.state.isLoadingDataCancel ? <></> : 
                                            <Bar data={this.state.dataCancelByProduct} />
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                                    <strong>Cancel By City</strong>
                                    {
                                        this.state.isLoadingDataCancel ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <Divider sx={{mt: "5px", mb: "10px"}} />
                                    }
                                    <Box sx={{pl: "20%", pr: "20%", pt: "20px", pb: "20px"}}>
                                        {
                                            this.state.isLoadingDataCancel ? <></> : 
                                            <Bar data={this.state.dataCancelByCity} />
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{m: "5px", border: "solid 1px", borderRadius: "5px", padding: "5px"}}>
                            <strong>List Data Cancel</strong>
                            {
                                this.state.csHelpCategoriesLoading ? <LinearProgress sx={{mt: "5px", mb: "10px"}} /> : <><br /><br /></>
                                // <Divider sx={{mt: "5px", mb: "10px"}} />
                            }
                            <Box>
                                <TableContainer>
                                    <Table aria-label="sticky table" size='small'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>Sales Name</strong></TableCell>
                                                <TableCell><strong>Kategori Cancel</strong></TableCell>
                                                <TableCell><strong>Sub Kategori</strong></TableCell>
                                                <TableCell align='right'><strong>Jumlah Leads</strong></TableCell>
                                                <TableCell><strong>Action</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.groupedLeadsCancel?.map((row) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                                    <TableCell>{row.salesName}</TableCell>
                                                    <TableCell>{row.groupReason}</TableCell>
                                                    <TableCell>{row.reason}</TableCell>
                                                    <TableCell align='right'>{row.leads.length}</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            );
                                            })}
                                        </TableBody>
                                        <TableFooter>
                                            {/* <TableRow>
                                                <TableCell><strong>Total</strong></TableCell>
                                                <TableCell align='right'><strong>{this.state.totalByWeeks?.kategoriProblem?.week1}</strong></TableCell>
                                                <TableCell align='right'><strong>{this.state.totalByWeeks?.kategoriProblem?.week2}</strong></TableCell>
                                                <TableCell align='right'><strong>{this.state.totalByWeeks?.kategoriProblem?.week3}</strong></TableCell>
                                                <TableCell align='right'><strong>{this.state.totalByWeeks?.kategoriProblem?.week4}</strong></TableCell>
                                            </TableRow> */}
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Box>
                            
                        </Box>
                    </Grid>

                </Grid>
            </Box>
        );
    }
}
 
export default ReportPerformaDataCancelNew;